<template>
  <div
    class="comet-thumbnail asset-module__image video-wrapper"
    :class="{
      'asset-module__image--transparent': useTransparentBackground,
      'video-wrapper--contain': imageSettings === 'letterbox' && thumbnailUrl,
    }"
  >
    <div class="asset-module__video-player">
      <VideoPlayer
        ref="videoPlayer"
        v-if="video"
        :key="videoPlayerKey"
        :autoplay="autoplay"
        :loop="loop"
        :module-theme="moduleTheme"
        :video="video"
        :start-time="startTime"
        :stop-time="stopTime"
        :scale="scale"
        :theme-name="themeName"
        :mode="mode"
        :canvasName="canvasName"
        :asset-id="assetId"
        @play="onPlay"
        @pause="onPause"
        @ended="onEnded"
      />
      <LoadingIndicator
        absolute
        v-else
        class="video-wrapper__image-loading-indicator"
      />
    </div>
  </div>
</template>

<script>
import VideoPlayer from '@/components/media/VideoPlayer.vue';
import LoadingIndicator from '@/components/LoadingIndicator.vue';

export default {
  name: 'VideoViewer',
  components: {
    VideoPlayer,
    LoadingIndicator,
  },
  props: {
    autoplay: Boolean,
    loop: {
      type: Boolean,
      default: false,
    },
    imageSettings: {
      type: String,
      default: null,
    },
    moduleTheme: {
      type: Object,
      default: null,
    },
    scale: {
      type: Number,
      default: 1,
    },
    thumbnailUrl: {
      type: Object,
      default: null,
    },
    useTransparentBackground: Boolean,
    video: {
      type: Object,
      default: null,
    },
    themeName: {
      type: String,
      default: 'default',
    },
    startTime: {
      type: Number,
      default: null,
    },
    stopTime: {
      type: Number,
      default: null,
    },
    mode: {
      type: String,
      default: null,
    },
    assetId: {
      type: String,
      default: null,
    },
    canvasName: {
      type: String,
      default: null,
    },
  },
  emits: [
    'pause',
    'ended',
    'play',
  ],
  computed: {
    videoPlayerKey() {
      // Force the video player to reload if the video changes.
      return this.video?.id || this.video?.uploadId || undefined;
    },
  },
  methods: {
    pause() {
      if (this.$refs.videoPlayer) this.$refs.videoPlayer.pause();
    },
    reset() {
      if (this.$refs.videoPlayer) this.$refs.videoPlayer.reset();
    },
    onPlay() {
      this.$emit('play');
    },
    onPause() {
      this.$emit('pause');
    },
    onEnded() {
      this.$emit('ended');
    },
    paused() {
      if (!this.$refs.videoPlayer) return true;
      return this.$refs.videoPlayer.paused();
    },
  },
};
</script>

<style lang="stylus">
.video-wrapper {
  &__image-loading-indicator {
    z-index: 100;
  }

  &--contain {
    .video-player__thumbnail {
      .video-player__thumbnail-image-container .video-player__thumbnail-image {
        background-repeat: no-repeat;
        background-size: contain;
      }
    }
  }
}
</style>
